import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '@/utils/lib/axios';
import { env } from '@/utils/constants/env';
import type { GenerateAIResponse } from '@/types/generate-ai';
import type { CultureAIGenerateFormData } from './culture-ai-generate.schema';

interface UseGenerateCultureOptions {
  tenantId: string;
}

export const useGenerateCulture = ({ tenantId }: UseGenerateCultureOptions) => {
  return useMutation<GenerateAIResponse, Error, CultureAIGenerateFormData>({
    mutationFn: async (data: CultureAIGenerateFormData) => {
      try {
        const response = await axiosInstance.post<GenerateAIResponse>(
          `${env.apiTasklistBaseUrl}/api/v1/compro/${tenantId}/ai/generate-culture`,
          data,
        );
        return response.data;
      } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to generate culture';
        throw new Error(message);
      }
    },
  });
};
